import $ from 'jquery';
import moment from 'moment';
import profileStoreIsAvailable from 'lib/profile-store-utils';
import ProfileStore from 'framework/stores/ProfileStore';


function updateContent(profile) {
	var data = profile || ProfileStore.getInitialData();
	let expirationDate = moment().subtract(30, 'days');
	let joinDate = (data && data.memberDetails && data.memberDetails.joinDate) ? moment(data.memberDetails.joinDate, moment.ISO_8601) : null;

	if(joinDate
			&& joinDate.isAfter(expirationDate)
			&& data.memberDetails && data.memberDetails.resourceKeys
			&& data.memberDetails.resourceKeys.length > 0) {
		$('.action-list').removeClass('hide');
	}
}

export default updateContent;


if (profileStoreIsAvailable) {

    updateContent();

    var unsubscribeProfile = ProfileStore.listen((profile) => {
        updateContent(profile);
        unsubscribeProfile();
    });
}
